<template>
  <div
    class="ma-0 pa-5 pt-5 mx-auto"
    style="min-height: 100%; max-width: 1000px;"
  >
    <h1
      class="mt-0 mb-5 px-10"
      style="color: white;"
    >My Payments</h1>

    <v-card
      v-if="payments && payments.length > 0"
      style="max-width: 700px;"
      class="mx-auto"
    >
      <v-select
        v-model="property_id"
        :items="propertyItems"
        label="Property"
        style="color: white;"
        class="pa-5 pb-0"
      />

      <v-expansion-panels
        v-if="propertyPayments.length > 0"
        class="mx-auto px-0"
        accordion
        focusable
      >
        <v-expansion-panel
          v-for="(pay, i) in propertyPayments"
          v-if="pay.payment_date"
          :key="'payment' + i"
        >
          <v-expansion-panel-header>
            <span>{{ convertDate(pay.payment_date) }}&nbsp;&nbsp;-&nbsp;&nbsp;<b>${{ pay.amount}}</b></span>
          </v-expansion-panel-header>

          <v-expansion-panel-content
            class="px-6 pt-3"
          >
            For: <b>{{ capitalize(pay.type) }}</b><br>

            <div
              v-if="pay.type==='violation'"
            >Topic: <b>{{ pay.topic }}</b><br></div>

            <div
              v-if="pay.type==='due'"
            >Topic: <b>{{ pay.name }}</b><br></div>

            Payment Type: <b>{{ capitalize(pay.payment_type) }}</b><br>

            <div
              v-if="pay.payment_type==='PAYPAL'"
            >PayPal Confirmation ID: <b>{{ pay.paypal_confirm }}</b></div>

            Amount: <b>${{ pay.amount }}</b><br>

            Time: <b>{{ convertDateTime(pay.payment_date) }}</b><br>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>

    <div
      v-else-if="payments"
      class="d-flex flex-column align-center mt-5"
    >
      <h3
        style="color: white;"
      >You have no payment history.</h3>

      <v-btn
        color="accent"
        large
        class="mx-auto mt-3"
        style="min-width: 150px;"
        @click="$router.back()"
      >
        <v-icon
          class="mr-1"
        >mdi-arrow-left</v-icon>

        <span>Back</span>
      </v-btn>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Payments',

  components: {

  },

  props: {
    permissions: {
      type: Number,
      required: true,
    },

    properties: {
      type: Array,
      required: true,
    },

    payments: {
      type: Array,
      required: true,
    }
  },

  data: () => ({
    propertyPayments: [],
    property_id: '',
    proppop: false,
    propertyItems: [{
      text: 'All',
      value: 'all',
    }],
  }),

  watch: {
    properties(val) {
      if (val.length > 0)
        this.populateProperties();
    },

    payments() {
      this.updatePayments();
    },

    property_id() {
      this.updatePayments()
    }
  },

  methods: {
    updatePayments() {
      if (parseInt(this.property_id))
        this.propertyPayments = this.payments.filter((e) => { return e.property_id == val });
      else
        this.propertyPayments = this.payments;
    },

    capitalize(s) {
      return s.substr(0, 1).toUpperCase() + s.substr(1, s.length - 1);
    },

    convertDate(d) {
      if (d) {
        const d2 = new Date();
        d2.setUTCFullYear(parseInt(d.slice(0, 4)), parseInt(d.slice(5, 7)) - 1, parseInt(d.slice(8, 10)));
        d2.setUTCHours(0, 0, 0);
        return d2.toDateString().slice(4);
      }
    },

    convertDateTime(d) {
      if (d) {
        const d2 = new Date();
        d2.setUTCFullYear(parseInt(d.slice(0, 4)), parseInt(d.slice(5, 7)) - 1, parseInt(d.slice(8, 10)));
        d2.setUTCHours(parseInt(d.slice(12, 14)), parseInt(d.slice(15, 17)), parseInt(d.slice(18, 20)));
        return d2.toString().slice(4, 24)
      }
    },

    populateProperties() {
      this.properties.forEach((p) => {
        this.propertyItems.push({
          text: 'Lot #' + p.lot + ' <' + p.line1 + ' ' + p.line2 + ' ' + p.city + ', ' + p.state + '>',
          value: p.id,
        })
      });
      this.proppop = true;
    }
  },

  created () {
    this.$emit('refresh-payments');
    this.populateProperties();

    if (parseInt(this.$route.query.property))
      this.property_id = parseInt(this.$route.query.property);
    else
      this.property_id = 'all';
  },
};
</script>

<style scoped>

</style>
